import React, { FC, useState } from 'react'
// import { makeStyles } from '@material-ui/styles'
import classNames from 'classnames'
import scrollTo from 'gatsby-plugin-smoothscroll'

import SwipeableDrawer from '@material-ui/core/SwipeableDrawer'
import Button from '@material-ui/core/Button'
import ListItem from '@material-ui/core/ListItem'

// import DesignButton from 'components/lv1/designButton'
// import SelectLanguage from 'components/lv1/selectLanguage'

import StylesModule from 'components/lv3/drawerMenu.module.scss'

import { MessageProps } from 'message/index.props'

import LogoImg from 'images/logo/westin.png'
import MenuIcon from 'images/icon_menu.svg'

export interface drawerMenuProps {
  message: MessageProps
  lang: string
}
interface MenuLinksProps extends drawerMenuProps {
  cssClass: string
}

const drawerMenu: FC<drawerMenuProps> = ({ message, lang }) => {
  const [state, setState] = useState({
    drawerOpen: false,
  })

  function toggleDrawer() {
    setState({
      drawerOpen: !state.drawerOpen,
    })
  }

  function closeDrawer(targetId?: string) {
    setState({
      drawerOpen: false,
    })
    if (targetId) {
      setTimeout(function () {
        scrollTo(targetId)
      }, 100)
    }
  }

  const MenuLinks: FC<MenuLinksProps> = ({ message, lang, cssClass }) => {
    return (
      <>
        <li>
          <ListItem
            button
            onClick={() => {
              closeDrawer('#message')
            }}
            classes={{
              root: cssClass,
            }}
          >
            {message.global.message}
          </ListItem>
        </li>
        <li>
          <ListItem
            button
            onClick={() => {
              closeDrawer('#spa')
            }}
            classes={{
              root: cssClass,
            }}
          >
            {message.global.spa}
          </ListItem>
        </li>
        <li>
          <ListItem
            button
            onClick={() => {
              closeDrawer('#room')
            }}
            classes={{
              root: cssClass,
            }}
          >
            {message.global.room}
          </ListItem>
        </li>
        <li>
          <ListItem
            button
            onClick={() => {
              closeDrawer('#kasuien')
            }}
            classes={{
              root: cssClass,
            }}
          >
            {message.global.kasuien}
          </ListItem>
        </li>
        <li>
          <ListItem
            button
            onClick={() => {
              closeDrawer('#restaurant')
            }}
            classes={{
              root: cssClass,
            }}
          >
            {message.global.restaurant}
          </ListItem>
        </li>
        <li>
          <ListItem
            button
            onClick={() => {
              closeDrawer('#other')
            }}
            classes={{
              root: cssClass,
            }}
          >
            {message.global.other}
          </ListItem>
        </li>
      </>
    )
  }

  return (
    <section>
      <SwipeableDrawer
        anchor="right"
        open={state.drawerOpen}
        onClose={toggleDrawer}
        onOpen={toggleDrawer}
        classes={{
          root: StylesModule.drawer,
          paper: StylesModule.paper,
        }}
      >
        <div>
          <ul className={classNames(StylesModule.drawer__list)}>
            <li>
              <Button
                onClick={() => {
                  closeDrawer()
                }}
              >
                <div className={classNames(StylesModule.drawer__logo)}>
                  <img src={LogoImg} alt={message.global.westinkyoto.name} />
                </div>
              </Button>
            </li>
            <MenuLinks
              message={message}
              lang={lang}
              cssClass={StylesModule.drawer__listItem}
            />
          </ul>
        </div>
      </SwipeableDrawer>
      <div className={classNames(StylesModule.drawerMenu)}>
        <div className={classNames(StylesModule.drawerMenu__menu)}>
          <div className={classNames(StylesModule.drawerMenu__logoWrap)}>
            <div className={classNames(StylesModule.drawerMenu__logo)}>
              <img src={LogoImg} alt={message.global.westinkyoto.name} />
            </div>
          </div>
          <div className={classNames(StylesModule.drawerMenu__link)}>
            <ul className={classNames(StylesModule.drawerMenu__list)}>
              <MenuLinks
                message={message}
                lang={lang}
                cssClass={StylesModule.drawerMenu__listItem}
              />
            </ul>
          </div>
          {/* <div className={StylesModule.topImage__wrap}>
            <div className={StylesModule.topImage__languageWrap}>
              <SelectLanguage language={message.global.language} />
            </div>
            <div className={StylesModule.topImage__reservationWrap}>
              <DesignButton
                label={message.global.reservation}
                to={message.global.reservation_button.url}
                design="top-fill"
              />
            </div>
          </div> */}
        </div>
        <div className={classNames(StylesModule.drawerMenu__button)}>
          <Button onClick={toggleDrawer} onKeyDown={toggleDrawer}>
            <img
              src={MenuIcon}
              className={classNames(StylesModule.drawerMenu__buttonImg)}
              alt="Menu Button"
            />
          </Button>
        </div>
      </div>
    </section>
  )
}

export default drawerMenu
